import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { CssBaseline } from '@mui/material';

import { onInitialize } from 'redux/actions/app.actions';
import { getContactSettings } from 'redux/actions/contactSettings.actions';

import ScrollToTopContainer from 'containers/ScrollToTopContainer';
import NavigationContainer from 'containers/NavigationContainer';
import WhatsAppPopup from 'components/commons/WhatsappPopup';

import useTypedSelector from 'hooks/useTypedSelector';
import { userSelector } from 'redux/selectors/auth.selector';
import { isClienteRole } from 'helpers/roles';

import { GlobalStyle } from 'styles/global';

import 'react-toastify/dist/ReactToastify.css';

const App: FunctionComponent = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(onInitialize());
    dispatch(getContactSettings());
  }, [dispatch]);

  const user = useTypedSelector(userSelector);

  return (
    <>
      <GlobalStyle />
      <CssBaseline />
      <ScrollToTopContainer />
      <ToastContainer />
      <NavigationContainer />
      {isClienteRole(user) && <WhatsAppPopup />}
    </>
  );
};

export default App;
